module.exports = __webpack_public_path__ + "media/ש.a08348ab.mp3";